export default {
  data() {
    return {
      headImg:'',
      form:{
        MaterielId:'',
        AutionModel:'',
        IsDeposit:'',
        Type:'1',
        ProductName:''
      },
      loadingflag:false,
      bidList:[],
      PageIndex:1,
      total:0,
      url:{
        list:SZH.assets.api + '/AuctionPurchase2/GetAuctionInfoByPaging',
        cuttent:SZH.assets.api + '/Custom/GetCurrentDateTime',
        GetListNews: SZH.assets.api + '/Market/GetListNews_XJ',
        GetNews: SZH.assets.api + '/Market/GetCustomNews_XJ',
        VerifyCustomGroup: SZH.assets.api + '/AuctionPurchase2/VerifyCustomGroup',
      },
      currentTime:'',
      setIntervalObj:null,
      newsList:[],
      dialogVisible: false,
      newDialog:"",
      dateTime:''
    }
  },
  methods: {
    turnTo(url,bid){
      let self = this;
      if(bid) {
        if(bid.IsJoinIn){
          let routeData = self.$router.push({
            path: url,
            query:{ id: bid.Id}
          });
        }else{
          self.$http.post(self.url.VerifyCustomGroup,{
            data:bid.Id
          }).then(result =>{
            if(result.state == true){
              let routeData = self.$router.push({
                path: url,
                query:{ id: bid.Id}
              });
            }else{
              self.$message.error(result.message)
            }
          }, () => {
          });
        }
      }
      else {
        self.$router.push({
          path: url
        })
      }
    },
    handleCurrentChange(val){
      this.PageIndex = val;
      this.getBidList();
    },
    handTab(){
      let that = this;
      that.PageIndex = 1;
      that.getBidList();
    },
    getBidList(){
      let self = this;
      self.$http.post(self.url.list,{
        PageSize:10,
        PageIndex:self.PageIndex,
        Data:self.form
      }).then(result =>{
        if(result.state == true && result.data.Data.length>0){
          self.loadingflag =false;
          self.total = result.data.TotalCount;
          self.bidList = result.data.Data;
          //  执行倒计时
          if(self.form.Type == 1){
            // self.beginTimeFun();
          }
        }else{
          self.loadingflag =false;
          self.bidList= [];
          self.total = 0;
        }
      }, () => {
        // self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });
    },

    //  公告
    GetListNewsFun() {
      let self = this;
      self.$http.post(self.url.GetListNews, {
        Count: 10
      }).then(result => {
        if (result.state == true) {
          self.newsList = result.data;
        } else {
          self.newsList = []
        }
      }, () => {
        self.$message.error('数据保存失败，请检查您的网络是否可用。');
      });
    },
    getMore() {
      this.$router.push({
        path: '/Menu/EnquiryNotice'
      });
    },
    downloadIt(item) {
      this.$router.push({
        path: '/Menu/EnquiryNoticeDetail',
        query: {
          Id: item.F_Id
        }
      });
    },
    //弹窗所用数据
    loadNewsDetail(){
      let self = this;
      self.$http.post(self.url.GetNews,{
        keyValue:""
      }).then(result=>{
        if(result.state == true && result.data){
          //判断时间
          self.getDate();
          if(result.data.F_StartTime && result.data.F_EndTime){
            let newStartTime = result.data.F_StartTime.replaceAll("T"," " );
            let newEndTime = result.data.F_EndTime.replaceAll("T"," " );
            if(self.dateTime<newStartTime || self.dateTime >newEndTime){
              self.dialogVisible = false;
              self.newDialog =  ''
            }else{
              self.dialogVisible = true;
              self.newDialog = result.data.F_Content

            }
          }
        }else{
          console.log(result.message)
        }
      })
    },
    getDate(){
      let yy = new Date().getFullYear();
      let MM = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hour = new Date().getHours();
      let minutes = new Date().getMinutes();
      let seconds = new Date().getSeconds();

      if (MM < 10) {
        MM = '0' + MM
      }
      if (dd < 10) {
        dd = '0' + dd
      }
      let hh = hour < 10 ? '0' + hour : hour;
      let mm = minutes < 10 ? '0' + minutes : minutes;
      let ss = seconds < 10 ? '0' + seconds : seconds;
      this.dateTime = yy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss;
    },
  },
  destroyed(){
    clearInterval(this.setIntervalObj)
  },
  computed: {

  },
  components: {},
  mounted() {
    this.headImg = SZH.assets.image;
    this.getBidList();
    this.GetListNewsFun();
    this.loadNewsDetail();


  }
}



// WEBPACK FOOTER //
// ./src/views/EnquiryModule/EnquiryList/EnquiryList.js